import { Badge } from "@/components/ui/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import type { JudgeCalibrationRun } from "@/services/adminModelCurrency";
import { formatDateTime } from "../programNews/formatters";
import { failingChecksText, formatDecimal, formatPercent } from "./helpers";

function ResultCell({ run }: { run: JudgeCalibrationRun }) {
  if (run.passed === null) return <span className="text-muted-foreground">Not scored</span>;
  const failing = failingChecksText(run.checks);
  return (
    <div className="space-y-0.5">
      <Badge variant={run.passed ? "default" : "destructive"}>
        {run.passed ? "Passed" : "Failed"}
      </Badge>
      {failing ? <p className="text-xs text-muted-foreground">{failing}</p> : null}
    </div>
  );
}

const CalibrationTable = ({ runs }: { runs: JudgeCalibrationRun[] }) => {
  if (runs.length === 0) {
    return (
      <p className="text-sm text-muted-foreground">
        No judge comparisons yet. They run once enough chats are labeled.
      </p>
    );
  }
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Judge model</TableHead>
          <TableHead>Role</TableHead>
          <TableHead title="Average gap between the judge's scores and yours (lower is better)">
            Typical score gap
          </TableHead>
          <TableHead title="How often the judge agreed with you on pass or fail">
            Pass/fail agreement
          </TableHead>
          <TableHead title="How much the judge's score moves when asked twice (lower is steadier)">
            Run-to-run steadiness
          </TableHead>
          <TableHead>Result</TableHead>
          <TableHead>Run</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {runs.map(run => (
          <TableRow key={run.id}>
            <TableCell className="font-medium">{run.judgeModel}</TableCell>
            <TableCell>{run.role === "incumbent" ? "Current" : "Candidate"}</TableCell>
            <TableCell>{formatDecimal(run.metrics.overallMae)}</TableCell>
            <TableCell>{formatPercent(run.metrics.passFailAgreement)}</TableCell>
            <TableCell>{formatDecimal(run.metrics.runToRunMae)}</TableCell>
            <TableCell>
              <ResultCell run={run} />
            </TableCell>
            <TableCell className="text-xs text-muted-foreground">
              {formatDateTime(run.ranAt)} · {run.goldenCount} labeled
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default CalibrationTable;
